module.exports = __webpack_public_path__ + "img/task-9.152dbc5c.png";